import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';


/**
 * wizStyleClass set style for the first children component
 * The objective is to avoid the creation of style attribute
 * This directive is the equivalent of ngStyle for wiz-components
 *
 * Exemple
 * <wiz-label [wizLabel]="Hello" [wizStyle]="{ 'background-color': 'red', 'color':'white'}"></wiz-label>
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[wizStyleClass]',
})
export class WizStyleClassDirective implements OnInit {
  /*style property*/
  @Input() wizStyleClass: string;

  constructor(private elementRef: ElementRef, private  renderer: Renderer2) {
  }

  ngOnInit(): void {

    for (const value of this.wizStyleClass.split(' ')) {
      if (value) {
        this.renderer.addClass(this.elementRef.nativeElement.children[0], value);
      }
    }
  }
}
